export default __webpack_public_path__ + "static/media/aws-cognito.3c679855.svg";